import { render, staticRenderFns } from "./BlockUSPList.vue?vue&type=template&id=50fb9282&"
import script from "./BlockUSPList.vue?vue&type=script&lang=js&"
export * from "./BlockUSPList.vue?vue&type=script&lang=js&"
import style0 from "./BlockUSPList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports